import "./App.css";
import HomePage from "./views/HomePage";

function App() {
	return (
		<div className="App">
			<HomePage />
		</div>
	);
}

export default App;
